/**
 * LandingSky.js
 *
 * The public landing page. Everything that makes it a *sky* page lives in
 * SkyPage; what is left here is the hero and the Login button — the only two
 * things about this page that are not shared with /login, /join-waitlist and
 * /forgot-password.
 *
 * Built from the approved design reference,
 * docs/design/landing-sky/landing-sky-reference.html, which is the source of
 * truth for layout, copy, colours, sizes, star-field parameters, and motion.
 * The reference is a fixed 1280x760 composition; this is the responsive-ish
 * production version of it (see the interim mobile note in SkyPage.css).
 *
 * The hero is the only content, so it is the page's <main>. SkyPage renders
 * `children` between the nav and the footer without adding a wrapper, so the
 * DOM is exactly what is written below.
 */

import React from 'react';
import { Link } from 'react-router-dom';

import SkyPage from './SkyPage';
import './LandingSky.css';

// The nav's right-hand side. Only the landing page offers Login there — the auth
// pages pass no navRight, since sending someone from /login to /login is not a
// useful affordance.
const LOGIN_LINK = (
  <Link to="/login" className="landing-sky-login">
    Login
  </Link>
);

// `ufo`: the saucer Easter egg appears on the landing page only (ruled October
// 19, 2026); the auth pages do not pass it. Switched off globally by SHOW_UFO
// in SkyUfo.js.
const LandingSky = () => (
  <SkyPage navRight={LOGIN_LINK} ufo>
    <main className="landing-sky-hero">
      <div className="landing-sky-eyebrow">Your quiet place to think on the Internet</div>
      <h1 className="landing-sky-headline">
        AIs are generic.
        <br />
        Your insights aren&#8217;t.
      </h1>
      <p className="landing-sky-sub">
        Constellation KG starts with a simple browser extension that lets you capture the
        information, insights, and ideas that are important to you, without asking you to
        sacrifice your privacy. Slowly, the shape of your thinking emerges: unique constellations
        of thought that evolve with you. Rather than an answer machine, Constellation KG recasts AI
        as a thinking partner grounded in your work.
      </p>
      {/* "their" is emphasis, not decoration — the sentence turns on the
          contrast between their AIs and your thinking — so it is <em> rather
          than a styled span. "your" stays upright by design. The italic face is
          loaded by SkyPage, not synthesized. */}
      <p className="landing-sky-cta">
        <Link to="/join-waitlist">Join us</Link> today and start grounding <em>their</em> AIs in
        your thinking.
      </p>
    </main>
  </SkyPage>
);

export default LandingSky;
